import { Button } from "../../components/Button"
import { HeaderContent } from "../../components/Header"
import { ActionsCell, Grid, OnRowClickCell } from "../../components/Table"
import { EsmModal } from '../../components/EsmModal';
import "./styles.scss"

export const CompleteESMScreen = ({
  saveNewESM,
  updateESM,
  removeESM,
  esmList,
  isUpdate,
  setModalIsOpen,
  modalIsOpen,
  dw,
  values,
  register,
  onChangeValues,
  openModalUpdate,
  goToDetails,
  control,
  handleSelectAll,
  isAllProjectSelected
}) => {
  const columns = [
    {
      id: 0,
      field: "title",
      label: "Titulo",
      width: "calc(100% - 720px)",
      cellRenderer: (props) => <OnRowClickCell {...props} goToDetails={goToDetails}/>
    },
    {
      id: 1,
      field: "description",
      label: "Descrição",
      // width: "calc(100% - 1100px)",
      cellRenderer: (props) => <OnRowClickCell {...props} goToDetails={goToDetails}/>
    },
    {
      id: 2,
      field: "Ações",
      label: "Ações",
      width: "90px",
      cellRenderer: (props) => <ActionsCell {...props} openModalUpdate={(data) => openModalUpdate(data)} removeESM={removeESM} />,
    },
  ];

  return (
    <>
      <HeaderContent className="flex-end">
        <div className="esm-new">
          <Button handleClick={() => setModalIsOpen(true)} label="Adicionar" color="orange" />
        </div>
      </HeaderContent>
      <Grid columns={columns} rows={esmList}/>
      <EsmModal
        {...{
          updateESM,
          esmList,
          saveNewESM,
          modalIsOpen,
          setModalIsOpen,
          dw,
          isUpdate,
          values,
          onChangeValues,
          isUpdate,
          register,
          control,
          goToDetails,
          handleSelectAll,
          isAllProjectSelected
        }}
      />
    </>
  )
}
